import { Component, OnInit } from '@angular/core';
import { TipRadneOpreme } from './tip-radne-opreme';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-tip-radne-opreme-modal-update',
  templateUrl: './tip-radne-opreme-modal-update.component.html'
})
export class TipRadneOpremeModalUpdateComponent
extends BaseModalUpdateComponent<TipRadneOpreme>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipRadneOpreme>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
